<template>
  <div style="width: 60%; position: relative; text-align: unset">
    <timeline
      ref="timeline"
      :items="items"
      :groups="groups"
      :options="options"
      class="visualization"
    ></timeline>
    <div v-for="(item, index) in dataIn" :key="index"
      >{{ item.EventTime }}: {{ item.KioskState }}</div
    >
  </div>
</template>

<script>
import moment from 'moment'

const tz = 'Europe/Berlin'

// Helper function
// Convert the inbound server ISO strings to moment objects, based on todays date.
const getMomentObj = (str) => {
  const date = new Date(str)
  const mins = date.getMinutes()
  const hours = date.getHours()
  const momentObj = moment.tz(tz)
  momentObj.hours(hours)
  momentObj.minute(mins)
  return momentObj
}
// Helper Function
// Get blocks (VisTime events) either side of a time.
const getBlock = (type, time, obj1, obj2) => {
  switch (type) {
    case 'start':
      return {
        id: 98,
        group: 0,
        start: moment()
          .tz(tz)
          .startOf('day')
          .toDate(),
        end: time,
        content: 'OFF',
        className: 'off',
        editable: false,
      }
    case 'normal':
      return {
        id: obj1.OperatingTimeId,
        group: 0,
        start: obj1.momentEventTime,
        end: obj2.momentEventTime,
        content: obj1.KioskState,
        className: obj1.KioskState.toLowerCase(),
        editable: true,
      }
    case 'end':
      return {
        id: obj1.OperatingTimeId,
        group: 0,
        start: time,
        end: moment()
          .tz(tz)
          .endOf('day')
          .toDate(),
        content: obj1.KioskState,
        className: obj1.KioskState.toLowerCase(),
        editable: true,
      }

    default:
      break
  }
}

const dataIn = [
  {
    OperatingTimeId: 2,
    KioskName: '*',
    DayOfWeek: -1,
    EventTime: '2020-07-01T23:00:00',
    KioskState: 'OFF',
  },
  {
    OperatingTimeId: 3,
    KioskName: '*',
    DayOfWeek: -1,
    EventTime: '2020-07-01T04:00:00',
    KioskState: 'ON',
  },
  {
    OperatingTimeId: 4,
    KioskName: '*',
    DayOfWeek: -1,
    EventTime: '2020-07-01T07:00:00',
    KioskState: 'ON',
  },
  {
    OperatingTimeId: 5,
    KioskName: '*',
    DayOfWeek: -1,
    EventTime: '2020-07-01T06:00:00',
    KioskState: 'OFF',
  },
]

const formatDataIn = (data) => {
  // Add some moment objects to our data
  data.forEach((d) => {
    d.momentEventTime = getMomentObj(d.EventTime)
    d.timestamp = getMomentObj(d.EventTime).format('x')
  })
  //   Sort the data into time ordered events
  data.sort((a, b) => {
    return a.timestamp - b.timestamp
  })
  // Create blocks
  const timelineData = []

  //   Get first block
  timelineData.push(getBlock('start', data[0].momentEventTime))

  data.forEach((event, index) => {
    if (index < data.length - 1) {
      timelineData.push(getBlock('normal', null, event, data[index + 1]))
    }
  })

  timelineData.push(getBlock('end', data.slice(-1).pop().momentEventTime, data.slice(-1).pop()))

  return timelineData
}

console.log(formatDataIn(dataIn))

export default {
  data() {
    return {
      dataIn: dataIn,
      groups: [
        {
          id: 0,
          content: 'MON',
        },
        {
          id: 1,
          content: 'TUE',
        },
        {
          id: 2,
          content: 'WED',
        },
        {
          id: 3,
          content: 'THU',
        },
        {
          id: 4,
          content: 'FRI',
        },
        {
          id: 5,
          content: 'SAT',
        },
        {
          id: 6,
          content: 'SUN',
        },
      ],
      items: formatDataIn(dataIn),
      options: {
        editable: {
          add: false,
          remove: false,
          updateGroup: false,
          updateTime: true,
          overrideItems: false,
        },
        stack: false,
        min: moment()
          .tz(tz)
          .startOf('day'),
        max: moment()
          .tz(tz)
          .endOf('day'),
        // Set VisTimeline to show data in the users timezone
        moment: function(date) {
          return moment.tz(date, tz)
        },
        onMoving: (item, callback) => {
          const min = moment()
            .tz(tz)
            .startOf('day')
            .format('x')
          const max = moment()
            .tz(tz)
            .endOf('day')
            .format('x')
          if (item.start < min) item.start = min
          if (item.start > max) item.start = max
          if (item.end > max) item.end = max

          callback(item)
        },
        onMove: (item, callback) => {
          var title =
            'Do you really want to move the item to\n' +
            'start: ' +
            moment.tz(item.start, tz).format('HH:mm') +
            '\n' +
            'end: ' +
            moment.tz(item.end, tz).format('HH:mm') +
            '?'

          this.$confirm(title)
            .then(() => {
              // Find the index of the item being moved the the 'items' array
              const itemIndex = this.items.findIndex(
                (_item) => _item.id === item.id
              )
              // We are not using Vis for the updates. Hence not using callback(item)
              // Update the reactive data in Vue and let that filter down to VisTimeline
              //
              // First update the item with the new start and end time.
              this.items[itemIndex].start = item.start
              this.items[itemIndex].end = item.end
              // Next, update the items either side of the updated item so that all the bars join together.
              this.items[itemIndex - 1].end = item.start
              this.items[itemIndex + 1].start = item.end
            })
            .catch(() => callback(null))
        },
        onRemove: (item, callback) => {
          const itemIndex = this.items.findIndex(
            (_item) => _item.id === item.id
          )
          if (itemIndex > -1) {
            this.items[itemIndex - 1].end = this.items[itemIndex + 1].start

            this.items.splice(itemIndex, 1)
          }
        },
        format: {
          minorLabels: function(date, scale, step) {
            switch (scale) {
              case 'millisecond':
                break
              case 'second':
                break
              case 'minute':
                return moment(date).format('HH:mm')

              case 'hour':
                return moment(date).format('HH')
              default:
                return moment(date).format('HH')
            }
            return moment(date).format('HH')
          },
          majorLabels: function(date, scale, step) {
            return ''
          },
        },
      },
    }
  },
  methods: {},
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler(items) {
        items.forEach((item, index) => {
          // Update the server model
          //
          // Find the index of from the server modal data, matching on their ids.
          const idx = this.dataIn.findIndex(
            (d) => d.OperatingTimeId === item.id
          );
          // If there is an match update the server model.
          // Note. the api returns an ISO string on GET, but expects and HH:mm on the patch/post
          // Hence the formatting below :!
          // 
          // If the item is an ON event we take the start time if its an OFF event we take the end time
          // const updateTime = item.content === 'ON' ? item.start : item.end
          const updateTime = item.content === 'ON' ? item.start : item.start
          if (idx > -1) {
            this.dataIn[idx].EventTime = moment
              .tz(updateTime, tz)
              .format('HH:mm')
          }
          // The last item in the array (as its time ordered) should always end at 'endOfDay'
          // If it does, we need to either take the previous item and end it there or add another item at the end of the array.
          // E.g. if an ON event is dragged away from  'endOfDay', add a off event to make the difference.
          if(items.length === index - 1) {
            console.log('end of arrayt')
          }
        })
      },
    },
  },
}
</script>
<style type="text/css">
.visualization {
  padding: 1rem;
}
.vis-item {
  position: absolute;
  color: #ffffff;
  border-width: 1px;
  display: inline-block;
  z-index: 1;
  font-weight: 600;
}
.vis-item.vis-range {
  border-style: solid;
  border-radius: 16px;
  text-align: center;
}
.on {
  border-color: #94b741;
  background-color: #94b741;
}
.off {
  border-color: #9e9e9e;
  background-color: #9e9e9e;
}
.vis-item.vis-range.on.vis-selected.vis-editable {
  border-color: #fff;
  background-color: #94b741;
  box-shadow: 0 0 0 2px #94b741;
}
div.vis-readonly,
div.vis-readonly.vis-selected {
  /* custom styling for readonly items... */
  background-color: #9e9e9ec5;
  border-color: #9e9e9e;
  color: white;
}

.vis-item.vis-range.off.vis-selected.vis-editable {
  border-color: #fff;
  background-color: #9e9e9e;
  box-shadow: 0 0 0 2px #9e9e9e;
}

.vis-panel.vis-bottom,
.vis-panel.vis-center,
.vis-panel.vis-left,
.vis-panel.vis-right,
.vis-panel.vis-top {
  border: 1px #f8f9fa00;
}

.vis-labelset,
.vis-labelset .vis-label {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-right: 20px;
}

.vis-timeline {
  border: 0px solid purple;
  /* font-family:  purisa, 'comic sans', cursive; */

  /* background: #ffecea; */
}

.vis-item {
  /* font-size: 15pt; */
}

/* .vis-item,
    .vis-item.vis-line {
      border-width: 3px;
    } */

.vis-time-axis .vis-grid.vis-minor {
  border-width: 2px;
  border-color: rgb(236, 236, 236);
}

.vis-time-axis .vis-grid.vis-major {
  border-width: 2px;
  border-color: #f991a200;
}

.vis-foreground .vis-group {
  border-color: rgb(236, 236, 236);
}

.vis-labelset,
.vis-labelset .vis-label {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-right: 20px;
  display: flex;
  flex-wrap: wrap;
  width: 80px;
  justify-content: flex-end;
  border-bottom: 0;
  font-size: 12px;
  font-weight: 600;
  align-items: center;
  color: #747475;
}
.vis-time-axis .vis-text {
  font-size: 12px;
  font-weight: 600;

  color: #747475;
}

.vis-itemset .vis-background,
.vis-itemset .vis-foreground {
}
</style>
